import type { UseQueryOptions } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";
import api from "../../../../../../api";
import urls from "../../../../../../urls";
import type { VollmachtFiles } from "../../../../../../utils/backend-types";

export const vollmachtVermarkterFilesQueries = {
  all: () =>
    queryOptions<VollmachtFiles>({
      queryKey: ["vollmachtVermarkterFiles"]
    }),
  bySiteId: (
    siteId: number,
    options?: Partial<UseQueryOptions<VollmachtFiles>>
  ) =>
    queryOptions<VollmachtFiles>({
      queryKey: ["vollmachtVermarkterFiles", { siteId }],
      queryFn: () => fetchVollmachtVermarkterFiles(siteId),
      ...options
    })
};

export function useVollmachtVermarkterFiles(
  siteId: number,
  options?: Partial<UseQueryOptions<VollmachtFiles>>
) {
  return useQuery(vollmachtVermarkterFilesQueries.bySiteId(siteId, options));
}

async function fetchVollmachtVermarkterFiles(siteId: number) {
  const vollmachtVermarkterFilesUrl = urls.api.vollmachtVermarkterFiles(siteId);
  const response = await api.get<VollmachtFiles>(vollmachtVermarkterFilesUrl);
  return response.data;
}
